import { capitalizeAllIfLower } from '@btime/helpers'
import { useLoggedUser } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import { Title } from '../../packages/kiti/components/presentation/Text'
import { UserAvatar } from '../../components/presentation/Avatar'
import { useHelpActions } from '../../utils/contexts/HelpProvider'
import IconText from '../../packages/kiti/components/presentation/IconText'
import LineSeparator from '../../packages/kiti/components/helpers/LineSeparator'

const WelcomeBar = () => {
  const { t } = useTranslation('home')
  const loggedUser = useLoggedUser()
  const title = t('welcome', { name: capitalizeAllIfLower(loggedUser.name) })
  const { openPrimaryHelpOption } = useHelpActions()

  return (
    <>
      <Grid align="center" justify="flex-start" gutter={0.5}>
        <UserAvatar user={loggedUser} />
        <Title size="h4" noMargin>
          {title}
        </Title>
        <Col flex={1} />
        <IconText
          onClick={openPrimaryHelpOption}
          iconRight="RiChatSmile2Line"
          iconSize={1.2}
          label={t('needHelp')}
          size="small"
          bold
          color="dark3"
          right
        />
      </Grid>
      <LineSeparator weight={5} />
    </>
  )
}

export default WelcomeBar
